import { Typography } from 'antd';
import { Trans } from 'react-i18next';

import { PRIVACY_POLICY } from '@/constants/routes';

import type {
  FieldConfig,
  SectionConfig,
} from '@/components/form/SchemaForm/types';

export const ACCEPTED_PRIVACY_POLICY_FIELD = 'accepted_privacy_policy';

function buildSignUpPrivacyAcceptanceField(): FieldConfig {
  return {
    name: ACCEPTED_PRIVACY_POLICY_FIELD,
    type: 'checkbox',
    label: (
      <Trans
        i18nKey="SIGN_UP_PRIVACY_ACCEPT"
        components={{
          a: (
            <Typography.Link
              href={PRIVACY_POLICY}
              target="_blank"
              rel="noopener noreferrer"
            />
          ),
        }}
      />
    ),
    componentProps: {
      'data-testid': 'sign-up-privacy-accept',
    },
  };
}

export function buildSignUpPrivacyAcceptanceSection(): SectionConfig {
  return {
    key: 'privacy-acceptance',
    fields: [buildSignUpPrivacyAcceptanceField()],
  };
}
